import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import {
  getLocalStorage,
  setLocalStorage
} from 'src/utils/browserStorageHandler';
import {
  EXPIRES_IN,
  REFRESH_TOKEN,
  USER_TOKEN
} from 'src/utils/constants/localStorageConstants';

import { RefreshAuthToken } from './RenewType';
import SimpleStore from '../../store/SimpleStore';
import { HTTP_HEADER_KEYS } from '../../utils/constants/HttpMethodsConstants';
import { httpService } from '../fetch/HttpService';
import { REFRESH_AUTH_TOKEN_QUERY } from '../GraphQL/Queries/RefreshAuthTokenQuery';
import { QueryRefreshAuthTokenArgs } from '../GraphQL/Queries/types';
import { graphQlRequest } from '../GraphQL/RequestHandler';

// renew User Token
export const renewUserToken = async (
  isRefreshCallPending: boolean,
  updateUserTokenRenewalApiCallStatus: (isRenewCallStatus: boolean) => void
) => {
  const refreshToken = getLocalStorage(REFRESH_TOKEN) || null;
  if (!refreshToken || (refreshToken && isRefreshCallPending)) {
    return null;
  }
  try {
    const headers = [HTTP_HEADER_KEYS.DEVICE_ID, HTTP_HEADER_KEYS.ESK];
    const requestParams: QueryRefreshAuthTokenArgs = {
      refreshToken
    };

    const refreshAuthToken: RefreshAuthToken = await renewAuthTokenLoggedInUser(
      requestParams,
      headers
    );

    if (refreshAuthToken.authToken) {
      setLocalStorage(USER_TOKEN, refreshAuthToken.authToken);
      SimpleStore.set(
        HTTP_HEADER_KEYS.AUTHORIZATION,
        refreshAuthToken.authToken
      );
      setLocalStorage(REFRESH_TOKEN, refreshAuthToken.refreshToken);
      if (refreshAuthToken?.expiresIn) {
        const expiresIn =
          Math.floor(new Date().getTime()) + Number(refreshAuthToken.expiresIn);
        setLocalStorage(EXPIRES_IN, expiresIn);
      }
      updateUserTokenRenewalApiCallStatus(false);
    }

    return refreshAuthToken;
  } catch (error) {
    updateUserTokenRenewalApiCallStatus(true);
    return httpService.logApiError(error);
  }
};

export const renewAuthTokenLoggedInUser = async (
  requestParams: QueryRefreshAuthTokenArgs,
  headers: string[]
) => {
  try {
    const res = await graphQlRequest(
      REFRESH_AUTH_TOKEN_QUERY,
      requestParams,
      GQL_QUERIES.REFRESH_AUTH_TOKEN_QUERY,
      headers
    );
    return res && res.refreshAuthToken;
  } catch (error) {
    console.error(error);
    return error;
  }
};
